const ACTION_TYPES = {
    OPEN_SIDEBAR: 'SIDEBAR_OPEN_SIDEBAR',
    CLOSE_SIDEBAR: 'SIDEBAR_CLOSE_SIDEBAR',
    SET_SIZE: 'SIDEBAR_SET_SIZE',
    TOGGLE_HISTORY: 'SIDEBAR_TOGGLE_HISTORY',
    SET_TYPE: 'SIDEBAR_SET_TYPE',
}

export default ACTION_TYPES 